import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router';
import classNames from 'classnames';
import * as navActions from '~/sidebarNav/actions';
import LibraryViewNav from '~/sidebarNav/components/LibraryViewNav';
import ArtifactViewNav from '~/sidebarNav/components/ArtifactViewNav';
import SearchFacetNav2 from '~/search2/components/SearchFacetNav';
import { SOURCECLEAR_COMPONENTS } from '~/constants/ModelConstants';
type SidebarNavProps = {
  actions: object;
  artifactState: object;
  libraryState: object;
  navigationState: object;
  searchDataState: object;
  myState: object;
};
class SidebarNav extends React.Component<SidebarNavProps, {}> {
  UNSAFE_componentWillMount = () => {
    this.props.actions.checkUserAuth();
  };
  toggleSubOption = (teamId, option) => {
    this.props.actions.toggleSubOption(teamId, option);
  };
  render() {
    const { navigationState: navState, myState } = this.props;
    const { activeParams } = navState;
    const expandedTeam = activeParams.teamId;
    const expandedExplore = true;
    let catalogClasses = classNames({
      'grid__item col-1-1 pv- cursor--pointer block link--no-underline': true,
      'hover-background--white-light':
        (!expandedExplore && !navState.exploreState.expanded) || expandedTeam,
      'color--white bg-color--primary active--white':
        navState.exploreState.expanded || (expandedExplore && !expandedTeam),
    });
    return (
      <div className="flex col-1-1 pv">
        <div className="flex position--relative col-1-1">
          <div className="mb col-1-1">
            <div className="grid">
              <Link
                className={catalogClasses}
                to={`/${SOURCECLEAR_COMPONENTS.VULNERABILITY_DATABASE.slug}/search`}
              >
                <div className="grid grid--full">
                  <div className="grid__item col-1-6 font--h6">
                    <i className="fa fa-database fa-fw" />
                  </div>
                  <div className="grid__item col-5-6 font--h6">
                    {SOURCECLEAR_COMPONENTS.VULNERABILITY_DATABASE.name}
                  </div>
                </div>
              </Link>

              <div className="grid__item col-1-1">
                <div className={'is-showing-1250'}>
                  <LibraryViewNav
                    activeState={navState.activeState}
                    libraryState={this.props.libraryState}
                    expandedSubOption={navState.expandedSubOption}
                  />
                  <ArtifactViewNav
                    activeState={navState.activeState}
                    artifactState={this.props.artifactState}
                    user={myState.me}
                    expandedSubOption={navState.expandedSubOption}
                  />
                  <div className="grid">
                    <Link
                      className={
                        'grid__item col-1-1 pv- position--relative link--no-underline' +
                        (navState.expandedSubOption === 'search'
                          ? ' color--primary'
                          : ' hover-background--white-light')
                      }
                      to={`/`}
                    >
                      <div
                        className={
                          'grid grid--full' +
                          (navState.expandedSubOption === 'search' ? ' color--primary' : '')
                        }
                      >
                        <div className="grid__item col-1-6 font--h7 pl-">
                          <i className="sci sci__search sci--fw" />
                        </div>
                        <div className="grid__item col-4-6 font--h7 pl--">Search</div>
                      </div>
                    </Link>
                    <div className={'grid__item col-1-1'}>
                      <SearchFacetNav2
                        activeState={navState.activeState}
                        filters={this.props.searchDataState.filters}
                        expandedSubOption={navState.expandedSubOption}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    artifactState: state.artifactState,
    libraryState: state.libraryState,
    navigationState: state.navigationState,
    searchDataState: state.searchDataState,
    myState: state.myState,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(navActions, dispatch),
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SidebarNav);
